import { renderInlineFormat } from '@/components/ChatResponseElements/InlineFormat'

/**
 * Thin wrapper over the shared inline formatter (Stage 2.2).
 *
 * Kept as its own module so the phase1 call sites can be reverted to a local
 * implementation independently of the demo path, which is the point of the
 * unification: one behaviour, two revertable seams.
 *
 * Behaviour gained by delegating: italic, strikethrough, links and `doc:`
 * references, none of which the previous two-pattern regex handled. Bold, code
 * and citation-marker handling are unchanged.
 */
export function renderInline(text, citations = [], keyBase = 'inline') {
  return renderInlineFormat(text, citations, keyBase)
}
